module.exports = __webpack_public_path__ + "img/3.3832fa9a.png";